var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('snackbar',{ref:"snackbar",attrs:{"baseSize":"100px","wrapClass":'',"colors":{open: '#333',info: '#3DBD7D',error: '#FA7377',warn: '#FF6600'},"holdTime":3000,"multiple":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }